import { gql } from '@apollo/client';

export const ProductsDetailsDocument = gql`
  query Products(
    $channel: String!
    $size: Int
    $format: ThumbnailFormatEnum
    $first: Int!
    $filter: ProductFilterInput
  ) {
    products(channel: $channel, first: $first, filter: $filter) {
      edges {
        node {
          attributes {
            attribute {
              slug
            }
            values {
              name
            }
          }
          name
          media {
            url(size: $size, format: $format)
          }
          slug
          collections {
            id
            name
            slug
            channel
          }
          pricing {
            displayGrossPrices
            onSale
            discount {
              gross {
                currency
                amount
              }
            }
            priceRange {
              start {
                gross {
                  currency
                  amount
                }
                net {
                  currency
                  amount
                }
                tax {
                  currency
                  amount
                }
              }
              stop {
                gross {
                  currency
                  amount
                }
                net {
                  currency
                  amount
                }
                tax {
                  currency
                  amount
                }
              }
            }
          }
        }
      }
    }
  }
`;
